import styled from 'styled-components';

export const DropdownList = styled.ul`
  max-height: ${(p) => `${p.maxHeight}px` || 'fit-content'};
  min-width: 80px;
  width: fit-content;
  background: var(--color-interface-neutral-light);
  box-shadow: var(--elevation-medium);
  border-radius: var(--radius-8);
  border: var(--spacing-s) solid var(--color-interface-neutral-light);
  gap: calc(var(--spacing-xxs) * 2);
  overflow-y: scroll;
  text-align: start;
  display: flex;
  flex-direction: column;
  padding: unset;
`;
